/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ESidePanelContent } from '../../models';

import { ISidePanelState } from '../state';

export const getSidePanel = createFeatureSelector<ISidePanelState>('sidePanel');

export const getIsSidePanelOpen = createSelector(getSidePanel, (state: ISidePanelState): boolean => state.isSidePanelOpened);

export const getSidePanelContent = createSelector(getSidePanel, (state: ISidePanelState): ESidePanelContent => state.sidepanelContent);
